// ko strings for messages/pricing.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const pricing: Dict = {
  "pricing.promo": "첫 달 {price}부터",
  "pricing.title": "원하는 목소리로 커버 만들기",
  "pricing.subtitle":
    "무제한 커버, 다운로드, 9만 3천 개 이상의 모든 목소리. 언제든 해지할 수 있어요.",
  "pricing.trialLinkInvalid":
    "이 무료 체험 링크는 다른 계정용이거나 만료되었어요. 일반 결제 화면을 보여 드려요.",

  "pricing.basic.subtitle": "커버 제작용",
  "pricing.creator.subtitle": "영상과 나만의 목소리용",
  "pricing.power.subtitle": "헤비 유저와 개발자용",
  "pricing.badge.popular": "가장 인기",

  "pricing.feature.unlimitedCovers": "무제한 커버",
  "pricing.feature.download": "커버, 보컬, 반주 다운로드",
  "pricing.feature.library": "전체 목소리 라이브러리",
  "pricing.feature.tts": "텍스트 음성 변환(TTS)",
  "pricing.feature.duets": "듀엣",
  "pricing.feature.credits": "크레딧 만료 없음",
  "pricing.feature.train": "목소리 무제한 학습",
  "pricing.feature.videos": "공유용 영상: Marble Run과 가사 영상",
  "pricing.feature.coins50": "매월 영상 코인 50개",
  "pricing.feature.priority": "우선 처리, 12시간당 250개",
  "pricing.feature.coinsUnlimited": "무제한 영상 코인",
  "pricing.feature.api": "매월 $25 상당의 API 크레딧",

  "pricing.compareAll": "전체 비교하기",
  "pricing.trust.cancel": "언제든 해지, 만든 결과물은 그대로",
  "pricing.trust.stripe": "Stripe 안전 결제",
  "pricing.trust.currency": "현지 통화로 표시",

  "pricing.compare.title": "요금제 비교",
  "pricing.compare.noPlan": "요금제 없음",
  "pricing.compare.browse": "모든 목소리 둘러보기와 듣기",
  "pricing.compare.covers": "커버",
  "pricing.compare.downloads": "다운로드",
  "pricing.compare.ttsDuets": "텍스트 음성 변환과 듀엣",
  "pricing.compare.song": "AI로 노래 만들기",
  "pricing.compare.train": "나만의 목소리 학습",
  "pricing.compare.videos": "영상(Marble Run, 가사)",
  "pricing.compare.priority": "우선 처리",
  "pricing.compare.api": "API 크레딧",
  "pricing.compare.unlimited": "무제한",
  "pricing.compare.coins50": "월 코인 50개",
  "pricing.compare.priorityLimit": "12시간당 250개",
  "pricing.compare.apiAmount": "월 $25",

  "pricing.faq.title": "자주 묻는 질문",
  "pricing.faq.noPlan.q": "요금제 없이 무엇을 할 수 있나요?",
  "pricing.faq.noPlan.a":
    "Jammable의 모든 목소리를 둘러보고 들어볼 수 있어요. 커버 만들기, 다운로드, 텍스트 음성 변환, 듀엣은 요금제가 필요해요.",
  "pricing.faq.basic.q": "Basic 요금제에는 무엇이 포함되나요?",
  "pricing.faq.basic.a":
    "Basic 요금제에는 무제한 커버, 다운로드, Jammable 전체 목소리 라이브러리, 텍스트 음성 변환, 듀엣이 포함되고 크레딧은 만료되지 않아요.",
  "pricing.faq.creator.q": "Creator 요금제는 Basic과 무엇이 다른가요?",
  "pricing.faq.creator.a":
    "Creator 요금제는 Basic의 모든 기능에 더해 목소리 무제한 학습, 공유용 영상 제작, 매월 Marble Run 코인 50개를 제공해요.",
  "pricing.faq.power.q": "Power 요금제는 무엇이 특별한가요?",
  "pricing.faq.power.a":
    "Power는 Creator의 모든 기능에 더해 우선 처리(12시간당 250개), 무제한 Marble Run 코인, 매월 $25 상당의 API 크레딧을 제공하는 전문 크리에이터용 요금제예요.",
  "pricing.faq.cancel.q": "구독은 언제든 해지할 수 있나요?",
  "pricing.faq.cancel.a":
    "네, 언제든 해지할 수 있어요. 혜택은 결제 기간이 끝날 때까지 유지돼요.",
  "pricing.faq.change.q": "요금제를 업그레이드하거나 다운그레이드할 수 있나요?",
  "pricing.faq.change.a":
    "물론이에요. 원할 때 언제든 업그레이드하거나 다운그레이드할 수 있고, 혜택도 그에 맞게 바뀌어요.",

  // components/pricing/PricingCard.js: shown under the price.
  "pricing.card.perYear": "연간 결제, 월 약 {price}",
  "pricing.card.firstMonthThen": "첫 달, 이후 월 {price}",
  "pricing.card.perMonth": "/월",
  "pricing.card.startFor": "{price}로 시작하기",
  "pricing.card.everythingIn": "{plan}의 모든 기능, 그리고",
  "pricing.cta.get": "{plan} 시작하기",
  "pricing.cta.yourPlan": "현재 요금제",
  "pricing.cta.manage": "요금제 관리",
  "pricing.cta.upgradeTo": "{plan}(으)로 업그레이드",
  "pricing.cta.updated": "구독이 변경되었어요!",
  "pricing.error.generic": "문제가 발생했어요. 고객지원에 문의해 주세요!",
  "pricing.seo.title": "요금제 | Jammable",
  "pricing.seo.description":
    "원하는 목소리로 AI 커버를 만드는 Jammable 요금제: 무제한 커버, 다운로드, 9만 3천 개 이상의 목소리. 현지 통화로 결제하고 언제든 해지할 수 있어요.",
};

export default pricing;
